/**
 * No operation.
 */
export const noop = () => {};

/**
 * transformDate - Checks if a given string is in ISO-Date format
 * if so a 'DD.MM.YYYY' representation of the date gets returned.
 *
 * @param  {type} date the string to check
 * @return {type}      'DD.MM.YYYY' representation of the ISO date
 */
export function transformDate (date) {
  if(date != null && typeof date === 'string'){
    let iso = /^([\+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-2])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T\s]((([01]\d|2[0-3])((:?)[0-5]\d)?|24\:?00)([\.,]\d+(?!:))?)?(\17[0-5]\d([\.,]\d+)?)?([zZ]|([\+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/;
    let match = date.match(iso);
    if(match == null){
      return date
    }
    let newDate = new Date(date);
    let dayPrefix = '';
    let monthPrefix = '';
    if (newDate instanceof Date && !isNaN(newDate.valueOf()) && date !== true && date !== false) {
      if(newDate.getDate() < 10){
        dayPrefix = '0';
      };
      if(newDate.getMonth() + 1 < 10){
        monthPrefix = '0';
      }
      return `${dayPrefix}${newDate.getDate()}.${monthPrefix}${newDate.getMonth() + 1}.${newDate.getFullYear()}`
    };
  }
  return date;
}


/**
 * formatDateToISOString - transforms date string to YYY-MM-DD date format.
 *
 * @param  {type} date the string to check
 * @return {type}  'YYYY-MM-DD' representation of the ISO date
 */

export function formatDateToISOString(dateString) {
  if (dateString == null) {
    return null;
  }
  const date = new Date(dateString);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
}

/**
 * formatDate - Formats a given date into the format DD.MM.YYYY.
 * 
 * @param  {String|Date} date The date to be formatted. Can be passed as a string or as a Date object.
 * @return {String}      The formatted date as a string in the format 'dd.MM.yyyy' or an empty string if an invalid date is passed.
 */
import { format } from 'date-fns';
export function formatDate(date) {
  if (!date) return '';
  return format(new Date(date), 'dd.MM.yyyy');
}


/**
 * firstLetterUpperCase - Transforms the first letter of a fiven string to
 * upper case.
 *
 * @param  {type} word Word to transform
 * @return {type}      Word with first letter in upper case
 */
export function firstLetterUpperCase (word) {
  if(word != null && typeof word === 'string'){
    return word.charAt(0).toUpperCase() + word.substr(1);
  }
  return word;
}

/**
 * calculateAge - Calculates the number of years between two given dates.
 *                Used for calculating the age of a child.
 *                (Function is not precise +- 4 days margin)
 *
 * @param  {type} birthdate  Chronological first date
 * @param  {type} targetDate Chronological second date
 * @return {type}            the number of years
 */
export function calculateAge (birthdate, targetDate) {
  if(birthdate === null || targetDate === null){
    return "-"
  }
  let seconds = (new Date(targetDate).getTime() - new Date(birthdate).getTime()) / 1000;
  let days = 0;
  let month = 0;
  let years = 0;
  if(seconds >= 0){
    days = Math.floor(seconds / 86400);
    month = Math.floor(days / 30.3);
    years = Math.floor(month / 12);
  }
  let rest = month % 12;
  return {
    year: years,
    month: rest
  }
}

/**
 * calculateAddedHours - Calculates the Wochenstunden for a betreuungszeit object
 *                      ( {montag: {von: "", bis: ""}} ...)
 *
 * @param  {type} betreuungszeiten  registration.betreuungszeit object
 * @param  {type} multiplicator = 1 number of children of the registration
 * @return {type}                   a string containing hours and minutes of
 *                                  the calculated Wochenstunden
 */
export function calculateAddedHours (betreuungszeiten, multiplicator = 1) {
  if(betreuungszeiten !== null){
    let minutes = 0;
    let daysPerWeek = 0;
    Object.keys(betreuungszeiten).forEach(item => {
      if(betreuungszeiten[item]){
         if(betreuungszeiten[item].von && betreuungszeiten[item].bis){
           let von = betreuungszeiten[item].von.split(':');
           let bis = betreuungszeiten[item].bis.split(':');
           let c = ((parseInt(bis[0]) - parseInt(von[0])) - 1) * 60;
           c += 60 - parseInt(von[1]) + parseInt(bis[1]);
           daysPerWeek++;
           minutes += c;
         }
      }
    })
    minutes *= multiplicator;
    let hours = (minutes / 60) >> 0;
    let rest = minutes % 60;
    return `${hours} Stunden und ${rest} Minuten an ${daysPerWeek} Tagen`;
  }
  return `Keine Wochenstunden angegeben.`;

}

/**
 * Converts seconds into a time format of minutes and seconds (mm:ss).
 * Adds a leading zero if the seconds are between 1 and 9.
 * 
 * @param {number} seconds - The number of seconds to be converted.
 * @returns {string} The time in mm:ss format.
 */
export function displayTimer(seconds) {
  let min = Math.floor(seconds / 60);
  let sec = seconds % 60;
  let prefix = '';
  if(sec <= 9 >= 1) {
    prefix = '0';
  }
  return `${min}:${prefix}${sec}`
}

/**
 * findNameFromID - Returns the name from a given array containing objects
 *                  with at least the fields id and name
 *
 * @param  {type} id          the id of the desired name
 * @param  {type} searchArray the array to search in
 * @return {type}             the name from the id object
 */
export function findNameFromID (id, searchArray) {
  if(id !== null && Array.isArray(searchArray)){
    let index = searchArray.findIndex(x => x.id === id);
    if(index > -1){
      return searchArray[index].name;
    }
  }
  return null;
}

/**
 * dateToSeconds - Converts a given iso date to milliseconds
 *
 * @param  {type} date Given iso date
 * @return {type}      Milliseconds of the given date
 */
export function dateToSeconds(date){
  if(date !== null){
      return new Date(date).getTime();
  }
  return null;
}

/**
 * Trims a time string to remove seconds, leaving only the hours and minutes.
 * If the input is a valid string, it returns the first five characters,
 * effectively cutting off seconds if they are present.
 * 
 * @param {string} timeString  The time string to be trimmed.
 * @returns {string} The trimmed time string in HH:mm format.
 */
export function cutSeconds(timeString) {
  if (timeString != null && typeof timeString === 'string') {
    return timeString.substring(0, 5);
  }
  return timeString;
}

/**
 * Converts a UTC date string to a CET/CEST date and time string, adjusting for the timezone difference.
 * 
 * @param {string} date - The UTC date string to be converted.
 * @returns {string} The date and time string in "YYYY-MM-DD, HH:mm:ss Uhr" format adjusted to CET/CEST.
 */
export function UTCtoCETandCEST(date) {
  let parseISOString = (s) => {
    let b = s.split(/\D+/);
    if(b.length === 6) {
      b.push('00'); 
    }
    return new Date(Date.UTC(b[0], --b[1], b[2], b[3], b[4], b[5], b[6]));
  };

  let newDate = parseISOString(date);
  let cetOffset = 1; 
  let seconds = newDate.getTime() / 1000;
  seconds += cetOffset * 3600; 
  let value = new Date(seconds * 1000).toISOString();
  let resultDate = value.slice(0, 10);
  let time = value.slice(11, 19);
  return `${resultDate}, ${time} Uhr`;
}


/**
 * Trims an ISO date string to keep only the date part, removing the time part if present.
 * If the input is a valid string, it returns the first ten characters,
 * which correspond to the date in the format YYYY-MM-DD.
 * 
 * @param {string} dateString - The ISO date string to be trimmed.
 * @returns {string} The trimmed date string in YYYY-MM-DD format.
 */
export function cutISOString(dateString) {
  if (dateString != null && typeof dateString === 'string') {
    return dateString.substring(0, 10);
  }
  return dateString;
}

/**
 * Trims a string to a maximum length of 75 characters. If the string exceeds this length,
 * it cuts the string to 75 characters and appends '[...]' to indicate truncation.
 * 
 * @param {string} value - The string to be potentially trimmed.
 * @returns {string} The trimmed string or the original string if it's under 75 characters.
 */
export function cutString(value) {
  if (typeof value === 'string' && value.length > 75) {
    return `${value.slice(0, 75)} [...]`;
  } else {
    return value;
  }
}

/**
 * Trims a string to a maximum length of 20 characters. If the string exceeds this length,
 * it cuts the string to 20 characters and appends '[...]' to indicate truncation.
 * 
 * @param {string} value - The string to be potentially trimmed.
 * @returns {string} The trimmed string or the original string if it's under 20 characters.
 */
export function cutString20(value) {
  if (typeof value === 'string' && value.length > 20) {
    return `${value.slice(0, 20)} [...]`;
  } else {
    return value;
  }
}



/**
 * compareLexicographical - Compares to string lexicographically
 *
 * @param  {type} a The first string
 * @param  {type} b The seconde string
 * @return {type}   -1, 1 or 0 depending on the comparison
 */
export function compareLexicographical(a, b){
  const nameA = a.name.toUpperCase();
  const nameB = b.name.toUpperCase();
    if (nameA < nameB) {
      return -1;
    } else if (nameA > nameB) {
      return 1;
    }
    return 0;
}

/**
 * flattenRegistration - Flattens a registration to depth one. Needs einrichtung
 *                       and einrichtungsarten to resolve fields.
 *
 * Example { kindesdaten: [vorname: 'Test']} => kindesdaten.0.vorname: 'Test'
 *
 * @param  {type} einrichtungen     [{name: '', id: ''}] for resolving
 * @param  {type} einrichtungsarten [{name: '', id: ''}] for resolving
 * @param  {type} registration      a registration
 * @return {type}                   a flattened registration object with
 *                                  paths as key and value as value
 */
export function flattenRegistration(einrichtungen, einrichtungsarten, registration){

  let flatten = (items, level, parent, res, obj) => {
    if(typeof items === 'object' && items !== null){
      Object.keys(items).forEach(key => {
        return flatten(items[key], ++level, `${parent}.${key}`, res, items);
      })

    // Special cases
    } else {
      if(["Eingliederungshilfe nach SGB VIII (KJHG)",
      "Eingliederungshilfe wegen körperlicher/geistiger Behinderung",
      "Eingliederungshilfe wegen seelischer Behinderung"].includes(items)) {
        let newParent = parent.replace(/integrationsbedarf.[0-9]/, items);
        res[newParent] = true;
        return res;
      }
      if(["PRIVAT", "ARBEIT", "HANDY", "FAX"].includes(items)){
        let newParent = parent.replace(/[0-9].kontaktnummernArt/, items);
        res[newParent] = obj.nummer;
        return res;

      }
      if([".priorities.0.id", ".priorities.1.id", ".priorities.2.id",
      ".priorities.3.id", ".priorities.4.id"].includes(parent)){
        res[parent] = findNameFromID(obj.id, einrichtungen);
        return res;
      }
      if(parent === ".einrichtungsart"){
        res[parent] = findNameFromID(items, einrichtungsarten);
        return res;
      }
      if(parent === ".zugeteilteEinrichtung"){
        res[parent] = findNameFromID(items, einrichtungen);
        if(items !== null){
          let index = einrichtungen.findIndex(x => x.id === items);
          if(index >= 0 && einrichtungen[index].einrichtungsnummer !== null){
            res['.Kita_ID'] = einrichtungen[index].einrichtungsnummer;
          } else {
            res[".Kita_ID"] = ' - ';
          }
        }
        return res;
      }
      if([".kindesdaten.0.kindId", ".kindesdaten.1.kindId", ".kindesdaten.2.kindId",
      ".kindesdaten.3.kindId", ".kindesdaten.4.kindId"].includes(parent)){
        res['.kindId'] = `${obj.vorname}_${obj.name}_${obj.geburtsdatum}`;
        return res;
      }

      if(parent.startsWith(".ferienbetreuung.")){
        if(parent === ".ferienbetreuung.kategorie") {
          switch (items) {
            case 0:
              res[parent] = "Keine Ferienbetreuung";
              break;
            case 1:
              res[parent] = "bis 15 Tage";
              break;
            case 2:
              res[parent] = "16–30 Tage";
              break;
            case 3:
              res[parent] = "ab 31 Tage";
              break;
            default:
              res[parent] = "Unbekannte Kategorie";
          }
          return res;
        }

        if(items === 1) {
          res[parent] = true;
          return res;
        }
        if(items === 0) {
          res[parent] = false;
          return res;
        }
      }


      res[parent] = items;
      return res;
    }
    return res;
  }
  return flatten(registration, 0, '', {}, null);
}

/**
 * flattenRegistration - Flattens a registration to depth one.
 *
 * @param  {Object} registration      a registration
 * @return {Object}                   a flattened registration object with
 *                                    paths as key and value as value
 */
export function flattenRegistrationStatistics(registration) {
  const flattened = {};

  const flatten = (items, parentKey) => {
    if (typeof items === 'object' && items !== null) {
      Object.keys(items).forEach(key => {
        flatten(items[key], parentKey ? `${parentKey}.${key}` : key);
      });
    } else {
      flattened[parentKey] = items;
    }
  };

  flatten(registration, '');
  return flattened;
}


/**
 * convertToCSV - Takes a dictionary and a flattend representation of a registration
 *                and converts it to a comma separated values string.
 *
 * Dict exmaple: { kindesdaten.0.vorname: 'Kind-1-Vorname'}
 *
 * @param  {type} dict      a dictionary mapping the flattend key paths to a
 *                          more human readable string
 * @param  {type} flattened the flattend registrations
 * @return {type}           a csv string
 */
export function convertToCSV(dict, flattened) {
  let result = '';
  const BOM = '\uFEFF';

  Object.keys(dict).forEach(dictKey => {
    result += `${dict[dictKey]};`;
  });
  result = result.substring(0, result.length - 1);
  result += '\n';

  flattened.forEach(registration => {
    Object.keys(dict).forEach(dictKey => {
      if (typeof registration[dictKey] !== 'undefined' && registration[dictKey] !== null) {
        let value = registration[dictKey];

        if (typeof value === 'string' && /^\d+$/.test(value) && value.startsWith('0')) {
          value = `="${value}"`;
        } else if (typeof value === 'string') {
          value = value.replace(/[\n\r]/g, ' ').replace(/"/g, '""');
        }

        result += `${value};`;
      } else {
        result += ' ;';
      }
    });
    result = result.substring(0, result.length - 1);
    result += '\n';
  });

  return BOM + result;
}




/**
 * saveFile - Saves a given data string to a file and triggers a download.
 *
 * @param {String} data - The data to be saved.
 * @param {String} filename - The name of the file to save.
 */
export function saveFile(data, filename = 'export.csv') {
  const blob = new Blob([data], { type: 'text/csv;charset=utf-8;' });
  if (navigator.msSaveBlob) {
    navigator.msSaveBlob(blob, filename);
  } else {
    const link = document.createElement("a");
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", filename);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
}


/**
 * convertToCSVStatistics - Converts a flattened representation of a registration
 *                          into a comma-separated values string.
 *
 * @param  {Array} flattened  the flattened registrations
 * @return {String}           a csv string
 */
export function convertToCSVStatistics(flattened) {
  let result = '';
  const BOM = '\uFEFF';

  if (!flattened || flattened.length === 0) {
    console.error("Flattened data is undefined or empty.");
    return '';
  }
  const headers = Object.keys(flattened[0]);
  result += headers.join(';') + '\n';

  flattened.forEach(registration => {
    headers.forEach(header => {
      if (registration && typeof registration[header] !== 'undefined' && registration[header] !== null) {
        let value = typeof registration[header] === 'string' ? registration[header].replace(/[\n\r]/g, ' ').replace(/"/g, '""') : registration[header];
        result += `"${value}";`;
      } else {
        result += ' ;';
      }
    });
    result = result.substring(0, result.length - 1);
    result += '\n';
  });

  return BOM + result;
}




/**
 * convertToCSV - Takes a dictionary and a flattend representation of a registration
 *                and converts it to a comma separated values string.
 *
 * Dict exmaple: { kindesdaten.0.vorname: 'Kind-1-Vorname'}
 *
 * @param  {type} dict      a dictionary mapping the flattend key paths to a
 *                          more human readable string
 * @param  {type} flattened the flattend registrations
 * @return {type}           a csv string
 */
 export function convertToCSVWINKITA(dict, flattened){
  let result = '';
  Object.keys(dict).forEach(dictKey => {
    result += `${dict[dictKey]};`
  })
  result = result.substring(0, result.length - 1);
  result += '\n'

  flattened.forEach(registration => {
      Object.keys(dict).forEach(dictKey => {
        if(typeof registration[dictKey] !== 'undefined' && registration[dictKey] !== null){
          result += `${(typeof registration[dictKey] === 'string' && registration[dictKey].replace(/[\n\r]/g,' ')) || registration[dictKey]};`
        } else {
          result += ' ;'
        }
      })
      result = result.substring(0, result.length - 1);
      result += '\n'
  })
  return result;
}


/**
 * prepareRegistrations - Gets the state from reducers that deal with
 *                        registrations. The state needs to contain the facilities.
 *
 *                        The methods calculates various things needed for
 *                        displaying the assignment view (statistics, resolved IDs etc. )
 *
 * @param  {type} state.einrichtungen   The facilities to resolve IDs
 * @param  {type} action.payload.response The registrations.
 * @return {type}         Object containing the prepared keys needed to display the
 *                        assignment and archive view.
 */
export function prepareRegistrations(state, action){

  // Calculating the rows with the vals needed for the table
  const newState = action.payload.response;
  let projection = [];
  let searchIndex = [];
  const er_facilities = state.einrichtungen.map(x => x.id);

  let selectNames = [];

  for (let i = 0; i < newState.length; ++i) {
      let aufnahmedatumVal = null;
      let aufnahmedatumSeconds = null;
      if (newState[i].aufnahmedatum !== null && newState[i].aufnahmedatum.von) {
          aufnahmedatumVal = transformDate(newState[i].aufnahmedatum.von);
          aufnahmedatumSeconds = dateToSeconds(newState[i].aufnahmedatum.von);
      }
      let assignedFacility = '-';
      if(findNameFromID(newState[i].zugeteilteEinrichtung, state.einrichtungen) !== null){
        assignedFacility = findNameFromID(newState[i].zugeteilteEinrichtung, state.einrichtungen);
      }

      const allRejected = (currentValue) => currentValue.status === 'ABGELEHNT';

      let tableRow = {
          id: newState[i].id,
          bemerkung: newState[i].bemerkung,
          comment: newState[i].kindesdaten[0].bemerkungen,
          priorities: JSON.parse(JSON.stringify(newState[i].priorities)),
          zugeteilteEinrichtung: {
              value: assignedFacility === '-' && newState[i].zugeteilteEinrichtung !== null ? 'Andere KBE' : assignedFacility === '-' ? null : assignedFacility,
              id: newState[i].zugeteilteEinrichtung,
              tooltip: `Zugeteilt an: ${assignedFacility}`,
              highlight: false
          },
          aufnahmedatum: [{
              value: aufnahmedatumVal,
              tooltip: calculateAddedHours(newState[i].betreuungszeit, newState[i].kindesdaten.length),
              highlight: false
          }],
          aufnahmedatumSeconds: aufnahmedatumSeconds,
          name: [],
          geburtsdatum: [],
          birthdateSeconds: dateToSeconds(newState[i].kindesdaten[0].geburtsdatum),
          wohnort: [],
          status: {
              value: newState[i].status,
              tooltip: "Status",
              highlight: false
          },
          iStatus: [],
          allRejected: newState[i].priorities.every(allRejected),
          internalPriority: newState[i].internalPriority,
          einrichtungsart: newState[i].einrichtungsart,
          facility_role_must_act: false
      };

      let integrationsbedarf = false;
      let integrationsbedarfTooltip = 'Integrationsbedarf';
      let isSingleParent = false;
      const bemerkung = newState[i].kindesdaten[0].bemerkungen;
      if (bemerkung && bemerkung.trim() !== '') {
        const preview =
          bemerkung.length > 50
            ? bemerkung.substring(0, 50).trim() + '...'
            : bemerkung.trim();
      
        tableRow.iStatus.push({
            value: 'b',
            tooltip: `${preview}`,
            highlight: true
        })
      }

      let all_verteter_berufstaetig = true;
      let at_least_one_verteter_berufstaetig = false;
      newState[i].vertreter.forEach(vertreter => {
        if(vertreter.berufstaetig && vertreter.berufstaetig !== null && vertreter.berufstaetig === 'JA') {
          at_least_one_verteter_berufstaetig = true;
        } else {
          all_verteter_berufstaetig = false;
        }
      })

      if(all_verteter_berufstaetig === true){
        tableRow.iStatus.push({
          value: 'BT',
          tooltip: 'Alle Verteter sind berufstätig',
          highlight: true
        })
      } else {
        if(at_least_one_verteter_berufstaetig === true) {
          tableRow.iStatus.push({
            value: 'bt',
            tooltip: 'Mindestens ein Vertreter ist berufstätig',
            highlight: true
          })
        }
      }

      if (newState[i].geschwister !== null &&
            newState[i].geschwister.length > 0){
              let gk_tooltip = 'Geschwisterkind';
              if(newState[i].geschwister[0].einrichtung && newState[i].geschwister[0].einrichtung !== null){
                gk_tooltip += ` - Einrichtung: ${newState[i].geschwister[0].einrichtung}`
              }
        tableRow.iStatus.push({
            value: 'gk',
            tooltip: gk_tooltip,
            highlight: true
        })
      }
      if (newState[i].aufnahmedatum !== null && newState[i].aufnahmedatum.von !== null) {
        // Wished admission date by parents
        let date = new Date(newState[i].aufnahmedatum.von);

        // Current year
        let year = new Date().getFullYear();
        let month = new Date().getMonth();

        // Its early in the year so registration belongs to previous season
        if(month <= 7){
          --year;
        }
        let seasonDate = new Date(`${year}-09-01`);
        let seasonDateSucc = new Date(`${++year}-08-31`);
        if((date.getTime() >= seasonDate.getTime()) && (date.getTime() <= seasonDateSucc.getTime())){
          tableRow.iStatus.push({
              value: 'u',
              tooltip: 'Unterjährig',
              highlight: true
          })
        }
      }

      // Sie sind dran - Filter for einrichtung role
      if(action.payload.user_role !== null && action.payload.user_role === 'ER' || action.payload.user_role === 'Einrichtung'){

        newState[i].priorities.forEach((prio, index) => {

          // Facility given in prio belongs to the user
          if(er_facilities.includes(prio.id)){

            // Registration is not assigned yet
            if(prio.status === null || prio.status === 'OFFEN'){

              // Check if prev prio did reject registration
              if(index === 0 || newState[i].priorities[index - 1].status === 'ABGELEHNT'){

                // Show only registrations that are not reclined
                if(newState[i].status !== 'ZURUECKGESTELLT') {
                  tableRow.facility_role_must_act = true;
                }  
              }
            }
          }
        })
      }
      if(newState[i].alternativesAufnahmedatum !== null && newState[i].alternativesAufnahmedatum.von !== null){
        tableRow.iStatus.push({
            value: 'ad',
            tooltip: `Alternatives Aufnahmedatum: ${newState[i].alternativesAufnahmedatum.von}`,
            highlight: true
        })
      }
      newState[i].kindesdaten.forEach(child => {
          if (child.integrationsbedarf !== null && child.integrationsbedarf.length > 0) {
              integrationsbedarf = true;
              tableRow.iStatus.push({
                  value: 'i',
                  tooltip: integrationsbedarfTooltip,
                  highlight: true
              })
          }
          let gender = "Kein Geschlecht angegeben";
          if (child.geschlecht !== null) {
              gender = child.geschlecht;
          };
          tableRow.name.push({
              value: `${child.name} ${child.vorname}`,
              tooltip: gender,
              sortVal: `${child.name}`
          });

          let age = null;
          let suffix = 'alt';
          if (newState[i].aufnahmedatum !== null && newState[i].aufnahmedatum.von) {
              age = calculateAge(child.geburtsdatum, newState[i].aufnahmedatum.von);
              suffix = 'alt zum Zeitpunkt der Aufnahme.'
          } else {
              age = calculateAge(child.geburtsdatum, new Date());
          }
          let yearString = 'Jahre';
          if (age && age.year === 1) {
              yearString = 'Jahr';
          }
          tableRow.geburtsdatum.push({
              value: transformDate(child.geburtsdatum),
              tooltip: `${age.year} ${yearString}, ${age.month} Monate ${suffix}`,
              years: age.year,
              months: age.month
          })

          // Child Vertreter name list, separated by comma. eg. 'Max Mustermann, Sabine Mustermann'
          let childWohntBei = child.wohnort;
          let childFirstVertreter = childWohntBei !== null ? childWohntBei.split(',')[0] : null;
          let found = false;

          // Resolving wohnort, child.wohnort lists the name of the parent
          // the child is living with
          if (childFirstVertreter !== null) {
              newState[i].vertreter.forEach(x => {
                  let vName = `${x.vorname} ${x.name}`.toUpperCase().trim();
                  if (vName === childFirstVertreter.toUpperCase().trim()) {
                      if (x.hauptwohnsitz.ort) {
                          found = true;
                          tableRow.wohnort.push({
                              value: x.hauptwohnsitz.ort,
                              tooltip: `${x.hauptwohnsitz.postleitzahl}, ${x.hauptwohnsitz.strasse} ${x.hauptwohnsitz.hausnummer}`
                          })
                      }
                  };
                  if(x.alleinerziehend){
                    if(!isSingleParent){
                      isSingleParent = true;
                      tableRow.iStatus.push({
                          value: 'a',
                          tooltip: 'Alleinerziehend',
                          highlight: true
                      })
                    }
                  }
              });
              if (!found) {
                  tableRow.wohnort.push({
                      value: null,
                      tooltip: 'Keine Angabe zum Wohnort gemacht. '
                  });
              }
          } else {
              tableRow.wohnort.push({
                  value: null,
                  tooltip: 'Keine Angabe zum Wohnort gemacht. '
              });
          }
      })

      let at_least_one_neuer_hauptwohnsitz = false;
      
      if (newState[i].vertreter
        .map(parent => parent.hasOwnProperty('neuerHauptwohnsitz') && parent.neuerHauptwohnsitz !== null && Object.keys(parent.neuerHauptwohnsitz).length > 0)
        .reduce((prev, curr) => { return prev || curr }, false)) {
          const nh_tooltip = 'Neuer Hauptwohnsitz';
          tableRow.iStatus.push({
            value: 'nh',
            tooltip: nh_tooltip,
            highlight: true
          });
        at_least_one_neuer_hauptwohnsitz = true;
      }

      let elternzeit = false;

      if (
        newState[i].vertreter
          .map(parent =>
            parent.hasOwnProperty('elternzeit') &&
            parent.elternzeit !== null &&
            Object.keys(parent.elternzeit).length > 0
          )
          .reduce((prev, curr) => prev || curr, false)
      ) {
        elternzeit = true;
      }

      let ferienbetreuung = false;
      let ferienbetreuungKategorie = null;
      let ferienbetreuungText = null;

      if (
        newState[i].ferienbetreuung &&
        newState[i].ferienbetreuung !== null &&
        typeof newState[i].ferienbetreuung.kategorie === 'number'
      ) {
        ferienbetreuungKategorie = newState[i].ferienbetreuung.kategorie;

        switch (ferienbetreuungKategorie) {
          case 0:
            ferienbetreuungText = 'Keine Ferienbetreuung';
            break;
          case 1:
            ferienbetreuungText = 'bis 15 Tage';
            break;
          case 2:
            ferienbetreuungText = '16–30 Tage';
            break;
          case 3:
            ferienbetreuungText = 'ab 31 Tage';
            break;
          default:
            ferienbetreuungText = 'Unbekannte Kategorie';
        }

        if (ferienbetreuungKategorie > 0) {
          ferienbetreuung = true;
        }
      }

      if (ferienbetreuung) {
        tableRow.iStatus.push({
          value: 'fb',
          tooltip: `Ferienbetreuung: ${ferienbetreuungText}`,
          highlight: true
        });
      }


      if (tableRow.iStatus.length === 0) {
          tableRow.iStatus = null
      }
      tableRow.benachrichtigungsstatus = newState[i].benachrichtigungsstatus;
      projection.push(tableRow);

      // Creating Search Index
      let vertreterArray = [];
      let childrenArray = [];
      let prioArray = [];
      let specialFeatures = [];
      let singleParent = false;

      if(tableRow.geburtsdatum.length !== 0){
        let ageInMonths = tableRow.geburtsdatum[0].years * 12 + tableRow.geburtsdatum[0].months;
        specialFeatures.push(`$$AGE-${ageInMonths}`);
      }
      if(tableRow.internalPriority !== null){
        specialFeatures.push(`INTERNALPRIO`);
      }
      if (tableRow.einrichtungsart !== null) {
        if(tableRow.einrichtungsart.split(',').length < 4) {
          generateCombinations(tableRow.einrichtungsart.split(','))
          .map(x => `EINRICHTUNGSART-${x.join(',').toUpperCase()}`)
          .forEach(x => specialFeatures.push(x))
        }
      }
      if(tableRow.facility_role_must_act === true){
        specialFeatures.push(`FACILITYROLEMUSTACT`);
      }
      if(tableRow.allRejected){
        specialFeatures.push("ALLREJECTED");
      }
      if(newState[i].alternativesAufnahmedatum !== null){
        specialFeatures.push("ALTERNATIVEDATE")
      }
      if(all_verteter_berufstaetig === true){
        specialFeatures.push("ALL_VERTRETER_BERUFSTAETIG")
      }
      if(at_least_one_verteter_berufstaetig === true){
        specialFeatures.push("AT_LEAST_ONE_VERTRETER_BERUFSTAETIG")
      }
      if (at_least_one_neuer_hauptwohnsitz === true) {
        specialFeatures.push("AT_LEAST_ONE_NEUER_HAUPTWOHNSITZ")
      }
      if (elternzeit === true){
        specialFeatures.push("ELTERNZEIT")
      }
      if (ferienbetreuung === true){
        specialFeatures.push("FERIENBETREUUNG")
      }
      // save all kinds of dates
      if (newState[i].aufnahmedatum !== null && newState[i].aufnahmedatum.von !== null) {
        specialFeatures.push(`AUFNAHMEDATUM-${newState[i].aufnahmedatum.von}`);
      }
      if (newState[i].alternativesAufnahmedatum !== null) {
        specialFeatures.push(`ALTAUFNAHMEDATUM-${newState[i].alternativesAufnahmedatum.von}`);
      }
      if (newState[i].erzeugungsDatum !== null) {
        const isoDateString = newState[i].erzeugungsDatum.slice(0, 10);
        specialFeatures.push(`EINGANGANMELDUNG-${isoDateString}`);
      }
      if (newState[i].aenderungsDatum !== null) {
        const isoDateString = newState[i].aenderungsDatum.slice(0, 10);
        specialFeatures.push(`LETZTEAENDERUNG-${isoDateString}`);
      }
      if (newState[i].lastNotificationDate !== null) {
        const isoDateString = newState[i].lastNotificationDate.slice(0, 10);
        specialFeatures.push(`LETZTEBENACHRICHTIGUNG-${isoDateString}`);
      }

      let singleParentFound = false;
      newState[i].vertreter.forEach(x => {
          vertreterArray.push(`${x.name.toUpperCase()} ${x.vorname.toUpperCase()}`);
          vertreterArray.push(`${x.vorname.toUpperCase()} ${x.name.toUpperCase()}`);
          vertreterArray.push(`${x.hauptwohnsitz.ort.toUpperCase().trim()}`);
          selectNames.push({
            id: selectNames.length,
            registrationID: newState[i].id,
            name: `${x.name} ${x.vorname} ${x.name}`,
            index: i,
            isParent: true,
            isChild: false,
            firstName: `${x.vorname}`,
            lastName: `${x.name}`,
            parentOf: `${newState[i].kindesdaten[0].vorname} ${newState[i].kindesdaten[0].name}`,
            age: null
          })

          if(x.alleinerziehend){
            singleParent = true;
            if(!singleParentFound){
              singleParentFound = true;
            }
          }
      });
      if(singleParent){
        specialFeatures.push("SINGLEPARENT");
      }
      if(newState[i].geschwister !== null && newState[i].geschwister.length > 0){
        specialFeatures.push("SIBLINGS");
      }
      if(newState[i].aufnahmedatum !== null && newState[i].aufnahmedatum.von !== null){
        let date = new Date(newState[i].aufnahmedatum.von);
        let year = new Date().getFullYear();
        let month = new Date().getMonth();

        if(month <= 7){
          --year;
        }

        let seasonDate = new Date(`${year}-09-01`);
        let seasonDateSucc = new Date(`${++year}-08-31`);
        
        if((date.getTime() >= seasonDate.getTime()) && (date.getTime() <= seasonDateSucc.getTime())) {
          specialFeatures.push("UNTERJAEHRIG");
        }
      }
      newState[i].kindesdaten.forEach(child => {
          let age = null;
          if (child.geburtsdatum) {
              age = calculateAge(child.geburtsdatum, new Date);
          }

          if(child.bemerkungen !== null && child.bemerkungen.length > 0){
            specialFeatures.push("BEMERKUNG");
          }

          if (child.integrationsbedarf !== null && child.integrationsbedarf.length >= 1){
            specialFeatures.push("INTEGRATIONSBEDARF");
          }

          if (child.schulkind === true) {
            specialFeatures.push("SCHULKIND-JA");
          } else {
            specialFeatures.push("SCHULKIND-NEIN");
          }

          if (child.schulkind === true && child.schule) {
            specialFeatures.push(`SCHULE-${String(child.schule).toUpperCase().trim()}`);
          }

          if (child.schulkind === true && child.schulklasse) {
            const normalizedClass = String(child.schulklasse).trim().toUpperCase().replace(/\s+/g, '');
            specialFeatures.push(`SCHULKLASSE-${normalizedClass}`);

            const numericMatch = normalizedClass.match(/^\d+/);
            if (numericMatch) {
              specialFeatures.push(`SCHULKLASSE-NUM-${numericMatch[0]}`);
            }
          }
          childrenArray.push(`${child.name.toUpperCase().trim()} ${child.vorname.toUpperCase().trim()}`)
          childrenArray.push(`${child.vorname.toUpperCase().trim()} ${child.name.toUpperCase().trim()}`)
          childrenArray.push(`${child.vorname.toUpperCase().trim()}`)
          childrenArray.push(`${child.name.toUpperCase().trim()}`)
          selectNames.push({
            id: selectNames.length,
            registrationID: newState[i].id,
            name: `${child.name} ${child.vorname} ${child.name}`,
            index: i,
            isParent: false,
            isChild: true,
            firstName: `${child.vorname}`,
            lastName: `${child.name}`,
            parentOf: null,
            age: age !== null ? `${age.year} Jahre alt` : null
          })

          let singleName = child.vorname.split(" ");
          if (singleName.length > 1) {
              childrenArray.push(`${singleName[0].toUpperCase()}`);
              childrenArray.push(`${singleName[0].toUpperCase()} ${child.name.toUpperCase()}`);
              childrenArray.push(`${child.name.toUpperCase().trim()} ${singleName[0].toUpperCase()}`);
          }
      });
      let c = 1;
      newState[i].priorities.forEach(kita => {
          let index = state.einrichtungen.findIndex(x => x.id === kita.id);
          if (index >= 0) {
              prioArray.push(state.einrichtungen[index].id.toUpperCase());
              prioArray.push(`${state.einrichtungen[index].id.toUpperCase()}-PRIO:${c}`);
          }
          c++;
      });
      if (newState[i].zugeteilteEinrichtung !== null) {
          let name = findNameFromID(newState[i].zugeteilteEinrichtung, state.einrichtungen);
          if (name !== null) {
              prioArray.push(name.toUpperCase());
          }
      };
      let registrationStatus = newState[i].status;
      if (newState[i].status === null){
        registrationStatus = 'OFFEN';
      }
      searchIndex.push({
          index: i,
          searchFlat: [...[].concat.apply([], vertreterArray),
              ...[].concat.apply([], childrenArray), ...prioArray,
              ...specialFeatures, registrationStatus
          ]
      });
  }
  selectNames.sort(compareLexicographical);
  for(let i = 0; i < selectNames.length; ++i){
    selectNames[i].id = i;
  }
  return {
      ...state,
      bedarfsAnmeldungen: newState,
      tableProjection: projection,
      tableFull: projection,
      isFetching: false,
      searchIndex: searchIndex,
      names: selectNames
  }
}

export function prepareRegistrationsStatistics(state, action) {
  const newState = action.payload.response;

  let tableFull = newState.map(item => ({
    ...item,
    kindGeburtsdatum: item.kindesdaten?.[0]?.geburtsdatum ?? "-",
    kindGeschlecht: item.kindesdaten?.[0]?.geschlecht ?? "-",
    kindGeburtsdatum: item.kindesdaten?.[0]?.geburtsdatum ?? "-",
    kindGeschlecht: item.kindesdaten?.[0]?.geschlecht ?? "-",
    kindGeburtsdatum: item.kindesdaten?.[0]?.geburtsdatum ?? "-",
    kindGeburtsort: item.kindesdaten?.[0]?.geburtsort ?? "-",
    kindGeschlecht: item.kindesdaten?.[0]?.geschlecht ?? "-",
    kindStaatsangehoerigkeit: item.kindesdaten?.[0]?.staatsangehoerigkeit ?? "-",
    kindKonfession: item.kindesdaten?.[0]?.konfession ?? "-",
    kindSprache: item.kindesdaten?.[0]?.sprache ?? "-",
    kindIntegrationsbedarf: item.kindesdaten?.[0]?.integrationsbedarf ?? null,
    erstellungsdatum: transformDate(item.erzeugungsDatum),
    betreuungsID: item.id,
    zugeteilteEinrichtung: item.zugeteilteEinrichtung ?? "-",
    einrichtungsart: item.einrichtungsart ?? "-",
  }));

  let tableProjection = tableFull.map(item => ({
    id: item.betreuungsID,
    kindGeburtsdatum: transformDate(item.kindGeburtsdatum),
    kindGeschlecht: item.kindGeschlecht,
    zugeteilteEinrichtung: item.zugeteilteEinrichtung,
    einrichtungsart: item.einrichtungsart,
    erstellungsdatum: item.erstellungsdatum,
  }));

  return {
    ...state,
    bedarfsAnmeldungStatistics: newState,
    tableProjection: tableProjection,
    tableFull: tableFull,
    isFetching: false,
  };
}


/**
 * getEntity - description
 *
 * @param  {type} obj description
 * @return {type}     description
 */
export function getEntity(obj){
  if(typeof obj === 'undefined' || obj === null){
    return 'Undefined';
  }
  if(Object.keys(obj).includes('zugeteilteEinrichtung')){
    return 'Bedarfsanmeldung';
  }
  if(Object.keys(obj).includes('minimalAlter')){
    return 'Einrichtungsart';
  }
  if(Object.keys(obj).includes('location')){
    return 'Einrichtung';
  }
  if(Object.keys(obj).includes('license')){
    return 'Einrichtungsbild';
  }
  if(Object.keys(obj).includes('traegerArt')){
    return 'Träger';
  }
  if(Object.keys(obj).includes('zuteilungszeitraum')){
    return 'Saisonparameter';
  }
  if(Object.keys(obj).includes('buergerserviceportalUrl')){
    return 'Mandantparameter';
  }
  if(Object.keys(obj).includes('senderName')){
    return 'Postkorbnachricht';
  }
  return 'Undefined'
}

/**
 * Generate all unique combinations given an array.
 * e.g. ['a','b'] => [['a'], ['a', 'b'], ['b'], ['b', 'a']].
 */
function generateCombinations(arr) {
  const results = [];

  function combine(currentCombination, remainingElements) {
    if (currentCombination.length > 0) {
      results.push(currentCombination.slice());
    }

    for (let i = 0; i < remainingElements.length; i++) {
      currentCombination.push(remainingElements[i]);
      const newRemaining = remainingElements.slice(0, i).concat(remainingElements.slice(i + 1));
      combine(currentCombination, newRemaining);
      currentCombination.pop();
    }
  }

  combine([], arr);
  return results;
}